/*jslint browser: true, vars: true, plusplus: true, devel: true, nomen: true, indent: 4, maxerr: 50 */
/*global $, define, require, window */
define(function (require) {
  'use strict';

  var DateTZ = require('tzdate'),
    timer = require('jquery.timer'),
    SEC = 1000,
    MIN = SEC * 60,
    HR = MIN * 60,
    signUpStart = oeApp.getData('liveClassStudentSignUpStart'),
    signUpEnd = oeApp.getData('liveClassStudentSignUpEnd'),
    joinActive = oeApp.getData('common').liveClassStudentJoinActiveTime,
    classTimer,
    lastOffsetFetchDate = 0,
    wolverineOffset = 0,
    CommonFunctions = require('common/CommonFunctions');

  // We use this function every 5 minutes to ask wolverine what time it has, and calculate a
  // local client time offset with that information
  function getOffset() {
    $.ajax({
      url: oeApp.getData('common').oeProgressServiceHost + '/v1/keepalive/time',
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + CommonFunctions.getCookie('OESSOTOK'),
      },
      success: function (wolverineTime) {
        var localTime = getMSTime(new DateTZ(oeApp.getCurrentTime()));
        wolverineOffset = wolverineTime - localTime;
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('Error fetching time from wolverine:', textStatus, errorThrown);
      },
    });
  }

  function getTimeString(ms) {
    var hr = parseInt(ms / HR, 10),
      min = parseInt((ms - hr * HR) / MIN, 10),
      sec = parseInt((ms - hr * HR - min * MIN) / 1000, 10);
    return (hr > 0 ? hr : '00') + ':' + (min > 9 ? min : '0' + min) + ':' + (sec > 9 ? sec : '0' + sec);
  }

  // Triggers Backbone events
  function timerAction(classTime, classDuration) {
    var now = getMSTime(new DateTZ(oeApp.getCurrentTime())),
      msToClassBegin,
      timeToClassBeginString,
      timeToSignUpString;
    var diff = (now - lastOffsetFetchDate) / 1000;
    // We want to get the offset if anything isn't defined, or every 5 minutes
    if (!wolverineOffset || !lastOffsetFetchDate || Math.abs(diff) > 300) {
      lastOffsetFetchDate = now;
      getOffset();
    }

    msToClassBegin = getMSTime(classTime) - (now + wolverineOffset);

    if (msToClassBegin >= 0) {
      timeToClassBeginString = getTimeString(msToClassBegin);

      if (msToClassBegin < signUpStart && msToClassBegin > signUpEnd) {
        Backbone.trigger('liveclass:sign-up-enable', timeToClassBeginString);
      } else if (msToClassBegin <= signUpEnd) {
        Backbone.trigger('liveclass:sign-up-too-late', timeToClassBeginString);
      } else {
        timeToSignUpString = getTimeString(msToClassBegin - signUpStart);
        Backbone.trigger('liveclass:sign-up-disable', timeToClassBeginString, timeToSignUpString);
      }
    } else {
      // This triggers getting new class data
      Backbone.trigger('timer:class-started');
      if (classTimer) {
        classTimer.stop();
      }
    }
  }

  function getMSTime(time) {
    return time.getTime();
  }

  return {
    setTime: function (classBegin, classDuration) {
      var me = this,
        action = _.partial(timerAction, classBegin);

      timerAction(classBegin, classDuration);

      if (classTimer) {
        classTimer.action = action;
        classTimer.reset();
      } else {
        classTimer = $.timer(action, SEC, true);
      }
    },

    // We use this function every 5 minutes to ask wolverine what time it has, and calculate a
    // local client time offset with that information
    getOffset: function () {
      getOffset();
      return wolverineOffset;
    },

    // Given wait time in ms, returns wait time as a string, e.g. '05:26:55'
    getTimeString: function (ms) {
      return getTimeString(ms);
    },

    getTimeUntilClassInMs: function (timeOfClass) {
      var nowInMs = getMSTime(new DateTZ(oeApp.getCurrentTime()));
      //initialize wolverineOffset
      getOffset();

      // We are allowing the user to join 2 minutes after the timeOfClass (liveClassStudentJoinActiveTime)
      return (
        getMSTime(new DateTZ(+timeOfClass + +oeApp.getData('common').liveClassStudentJoinActiveTime)) -
        (nowInMs + wolverineOffset)
      );
    },
  };
});



//////////////////
// WEBPACK FOOTER
// ./js/common/ClassTimer.js
// module id = 481
// module chunks = 26 27 28